module.exports = "/_next/static/images/fallback-image-9-16-da37f2067ad358225c343d5d18ec8a05.png";